import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { TranslocoService } from '@ngneat/transloco';


@Pipe({
    name: 'localizeNumber',
    pure: false,
    standalone: false
})
export class LocalizeNumberPipe implements PipeTransform {

    constructor(
        private translate: TranslocoService,
    ) { }

    transform(value: string | number, digitsInfo?: string): string {
        const decimalPipe = new DecimalPipe(this.translate.getActiveLang());
        return decimalPipe.transform(value, digitsInfo);
    }

}
